import { action, computed, makeAutoObservable, runInAction } from "mobx";
import { Api } from "../../common/Api";
import { EngToolStore } from "./EngToolStore";

export class WorkSubmissionStore {
  store: EngToolStore;
  loading = false;
  list = [];
  keyword = "";

  constructor(store: EngToolStore) {
    makeAutoObservable(this, {
      store: false,
      workSubmissions: computed,
    });
    this.store = store;
  }

  get workSubmissions() {
    const kw = this.keyword.toLocaleLowerCase();

    return this.list.filter(
      (x: any) => x.title.toLocaleLowerCase().includes(kw) || x.activityType.toLocaleLowerCase().includes(kw)
    );
  }

  @action
  refresh() {
    this.loading = true;
    Api.engTool
      .WorkSubmissions()
      .then((res) => {
        runInAction(() => {
          this.list = res.data.engToolWorkSubmissions;
        });
      })
      .finally(() => (this.loading = false));
  }
}
